module.exports = __webpack_public_path__ + "static/media/cockroach(23).fca8131c.PNG";